import prizeIconImgSrc from 'components/heroBanner/assets/prize-icon.gif'

export const Illustration = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={445}
    height={445}
    fill="none"
  >
    <circle cx={222.5} cy={222.5} r={222} stroke="#EBFF00" strokeDasharray="16 16" />
    <foreignObject width={300} height={300} x={73} y={63}>
      <img src={prizeIconImgSrc} alt="" />
    </foreignObject>
  </svg>
)
